import i18n, { type InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";

// Import all translations
import { defaultLanguage, supportedLanguages } from "./languages";
import enAbout from "./locales/en/about.json";
import enAuth from "./locales/en/auth.json";
import enCommon from "./locales/en/common.json";
import enNavigation from "./locales/en/navigation.json";
import enProfile from "./locales/en/profile.json";
import enSimulator from "./locales/en/simulator.json";
import nnAuth from "./locales/nn/auth.json";
import nnCommon from "./locales/nn/common.json";
import nnNavigation from "./locales/nn/navigation.json";
import nnProfile from "./locales/nn/profile.json";
import nnSimulator from "./locales/nn/simulator.json";
import noAbout from "./locales/no/about.json";
import noAuth from "./locales/no/auth.json";
import noCommon from "./locales/no/common.json";
import noNavigation from "./locales/no/navigation.json";
import noProfile from "./locales/no/profile.json";
import noSimulator from "./locales/no/simulator.json";
import smeAuth from "./locales/sme/auth.json";
import smeCommon from "./locales/sme/common.json";
import smeNavigation from "./locales/sme/navigation.json";
import smeProfile from "./locales/sme/profile.json";
import smeSimulator from "./locales/sme/simulator.json";

// Define the resources for i18n. english, norwegian bokmål, nynorsk and sami
export const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    simulator: enSimulator,
    profile: enProfile,
    about: enAbout,
  },
  no: {
    common: noCommon,
    navigation: noNavigation,
    auth: noAuth,
    simulator: noSimulator,
    profile: noProfile,
    about: noAbout,
  },
  nn: {
    common: nnCommon,
    navigation: nnNavigation,
    auth: nnAuth,
    simulator: nnSimulator,
    profile: nnProfile,
  },
  sme: {
    common: smeCommon,
    navigation: smeNavigation,
    auth: smeAuth,
    simulator: smeSimulator,
    profile: smeProfile,
  },
};

const i18nConfig: InitOptions = {
  resources,
  fallbackLng: defaultLanguage,
  supportedLngs: supportedLanguages,
  defaultNS: "common",
  ns: ["common", "navigation", "auth", "simulator", "profile"],

  detection: {
    order: ["localStorage", "navigator", "htmlTag"],
    caches: ["localStorage"],
    lookupLocalStorage: "i18nextLng",
  },

  interpolation: {
    escapeValue: false,
  },

  react: {
    useSuspense: false,
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
  },
  debug: process.env.NODE_ENV === "development",

  // Ensure immediate loading
  load: "languageOnly",
  preload: supportedLanguages,
};

i18n.use(initReactI18next).init(i18nConfig);

export default i18n;
